<nb-card accent="success">
  <nb-card-header>
    <div class="d-flex">
      <div class="flex-grow-1 d-flex align-items-center justify-content-center">
        <nb-icon icon="stop-circle-outline"></nb-icon>
        <div class="ml-2" i18n>Stopping Insight: {{ insight_id }}</div>
      </div>
      <button nbButton class="ml-3" (click)="close()">
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>
  <nb-card-body>
    <div class="d-flex flex-column">
      <div class="field-label" i18n>Reason<span style="color: red">*</span></div>
      <textarea nbInput fullWidth [(ngModel)]="reason" [ngModelOptions]="{ standalone: true }"></textarea>
      <div class="mt-4" i18n>Are you sure you want to terminate this insight run?</div>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <div class="d-flex justify-content-end">
      <button nbButton (click)="close()" i18n>No</button>
      <button nbButton class="ml-3" [disabled]="!reason" status="danger" (click)="terminate()" i18n>Yes</button>
    </div>
  </nb-card-footer>
</nb-card>
